module.exports = __webpack_public_path__ + "static/media/newsUpdate.fb2c2443.svg";